"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMultiObjectSelector = exports.useSingleObjectSelector = void 0;
var react_1 = require("react");
function useSingleObjectSelector(options) {
    var _a = (0, react_1.useState)(options.initialSelectedItem || null), value = _a[0], setValue = _a[1];
    (0, react_1.useEffect)(function () {
        setValue(options.initialSelectedItem);
    }, [options.initialSelectedItem]);
    var mappedItems = (0, react_1.useMemo)(function () {
        if (options.mapItem) {
            return options.items.map(options.mapItem);
        }
        return options.items || [];
    }, [options.items, options.mapItem]);
    var isSelected = function (item) {
        if (options.selector) {
            return options.selector(value) === options.selector(item);
        }
        return value === item;
    };
    return {
        isSelected: isSelected,
        select: function (item) {
            setValue(item);
            if (options.onChange) {
                options.onChange(item);
            }
        },
        selectedItem: value,
        items: mappedItems,
    };
}
exports.useSingleObjectSelector = useSingleObjectSelector;
function useMultiObjectSelector(options) {
    var _a = (0, react_1.useState)(options.initialSelectedItems || []), value = _a[0], setValue = _a[1];
    (0, react_1.useEffect)(function () {
        setValue(function (value) { return options.initialSelectedItems || value; });
    }, [options.initialSelectedItems]);
    var mappedItems = (0, react_1.useMemo)(function () {
        if (options.mapItem) {
            return options.items.map(options.mapItem);
        }
        return options.items || [];
    }, [options.items, options.mapItem]);
    var selector = function (items, item) {
        if (options.selector) {
            return items.some(function (maybeItem) {
                return options.selector(maybeItem) === options.selector(item);
            });
        }
        return items.includes(item);
    };
    var isSelected = function (item) { return selector(value, item); };
    return {
        isSelected: isSelected,
        select: function (item) {
            var _a;
            setValue(function (currentItems) {
                if (!item) {
                    return currentItems;
                }
                if (selector(currentItems, item)) {
                    if (options.selector) {
                        return currentItems.filter(function (maybeItem) { return options.selector(maybeItem) !== options.selector(item); });
                    }
                    return currentItems.filter(function (maybeItem) { return maybeItem !== item; });
                }
                return currentItems.concat(item);
            });
            (_a = options.onChange) === null || _a === void 0 ? void 0 : _a.call(options, value);
        },
        selectedItems: value,
        items: mappedItems,
        clearSelectedItems: function () {
            setValue([]);
        },
    };
}
exports.useMultiObjectSelector = useMultiObjectSelector;
//# sourceMappingURL=hooks.js.map